module.exports = __webpack_public_path__ + "static/media/current_trial_volunteers.209a71f3.png";